import normalize from 'json-api-normalizer';

import { Testimonial, TestimonialJSONAPIResponse } from './types';

export function serializeTestimonialFromAPI(json: TestimonialJSONAPIResponse): Testimonial {
    //@ts-ignore
    const { testimonial } = normalize(json);
    const dossierId = json.data.id;

    return testimonial[dossierId].attributes;
}
